import HeroSecondary from '@/design-system/molecules/HeroSecondary';
import { themeIntegration } from '@/utils/themeIntegration';

const IntegrationHeroSecondary = (props) => {
    return themeIntegration(HeroSecondary, props);
};

export default IntegrationHeroSecondary;
